<template>
  <div class="row">
    <div class="col-12">
      <SectionTitle icon="fas fa-user-circle" reverse :title="title" />
    </div>
    <div class="col-xs-12 col-sm-12">
      <DynamicFormList :items="students">
        <template #items="{ item, index }">
          <div class="col-12">
            <DynamicFormListItem
              class="bg-light-gray border-radius--light"
              :item="item"
            >
              <template>
                <StudentItem cols="col-md col-12" :item="item">
                  <template #actions>
                    <div class="col-md-2 mt-sm-4 text-right">
                      <action-button
                        class="btn-action-size-cancel"
                        i="fas fa-times-circle"
                        variant="outline-danger btn-cancel danger"
                        @click="() => remove(index)"
                      />
                    </div>
                  </template>
                </StudentItem>
              </template>
            </DynamicFormListItem>
          </div>
        </template>
      </DynamicFormList>
    </div>

    <div v-if="!hasAnyItems" class="col-12">
      <div class="bg-light-gray border-radius--light py-4 text-center">
        No posee información de estudiantes
      </div>
    </div>
    <div v-show="!AddPanelshow" class="col-12 text-right">
      <div class="col">
        <ActionButton
          class="ab-btn  ab-btn-success mt-3 pl-3 pr-3 btn-block-xs-only"
          i="fas fa-file-plus"
          text="Añadir"
          variant="success"
          @click="showHideAddPanel"
        />
      </div>
    </div>
    <div v-show="AddPanelshow" class="col-xs-12 col-sm-12">
      <validation-observer ref="StudentAdd" v-slot="{}" tag="form">
        <div class="bg-light-gray border-radius--light">
          <div class="row pl-3 pr-3 mb-2">
            <div class="col-md-3 mt-md-1 mt-sm-4">
              <validation-provider v-slot="{ errors }" rules="required">
                <label class="input-label">Número de SIE:</label>
                <custom-input
                  v-model="model.sie"
                  custom-error-msg="El Número de SIE es requerido."
                  :error="errors[0]"
                  :placeholder="'Escriba número de SIE'"
                />
              </validation-provider>
            </div>
            <div class="col-md-3 mt-md-1 mt-sm-4">
              <validation-provider v-slot="{ errors }" rules="required">
                <label class="input-label">Fecha de nacimiento:</label>
                <custom-date-picker
                  v-model="model.birthdate"
                  class-container=""
                  custom-error-msg="La fecha es requerida."
                  :error="errors[0]"
                  :max-date="new Date()"
                  placeholder="DD/MM/YYYY"
                />
              </validation-provider>
            </div>
            <div class="col-md-3 mt-md-1 mt-sm-4">
              <validation-provider
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'El Seguro Social es requerido.',
                  OnlyNumber: 'campo solo acepta número (enteros y positivos).',
                }"
                rules="required|OnlyNumber"
              >
                <label class="input-label">
                  Últimos 4 dígitos del seguro social:
                </label>
                <custom-input
                  v-model="model.ssn"
                  :custom-error-msg="errors[0]"
                  :error="errors[0]"
                  maxlength="4"
                  :placeholder="'****'"
                  type="password"
                />
              </validation-provider>
            </div>
            <div class="col-md-3 mt-md-1 mt-sm-4">
              <label class="input-label" />
              <action-button
                class="ab-btn ab-btn-success btn-block-xs-only"
                :i="`fa fa-check`"
                :responsive="true"
                variant="success"
                @click="studentAddInfo"
              >
                Validar
              </action-button>
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
    <div v-show="resultPanelshow" class="col-xs-12 col-sm-12">
      <div class="bg-light-gray border-radius--light">
        <div v-if="studentinfo.isValid" class="row pl-3 pr-3 mb-2">
          <div class="col col-sm col-12 mt-md-4 pb-2">
            <label class="input-label">Estudiante:</label>
            <div class="regular word-break color-gray">
              {{ studentinfo.fullName | empty }}
            </div>
          </div>
          <div class="col col-sm col-12 mt-md-4 pb-2">
            <label class="input-label">Edad:</label>
            <div class="regular word-break color-gray">
              {{ studentinfo.age | empty }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-12  mt-3 pl-3 pr-2 d-flex align-items-end justify-content-end"
    >
      <div class="col-md-3 mt-md-1 mt-sm-4">
        <action-button
          v-show="AddPanelshow"
          :i="`fas fa-times-circle`"
          :responsive="true"
          variant="outline-danger"
          @click="showHideAddPanel"
        >
          Cancelar
        </action-button>
      </div>
      <div
        v-show="saveShow && this.studentinfo.isValid"
        class="col-md-3 mt-md-1 mt-sm-4"
      >
        <action-button
          :i="`fas fa-save`"
          :responsive="true"
          variant="success"
          @click="saveHandler"
        >
          Guardar
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import { extend } from 'vee-validate';
import SectionTitle from 'SectionTitle';
import { DynamicFormList, DynamicFormListItem } from '@/components/common';
import ActionButton from 'ActionButton';
import StudentItem from './StudentItem';
import alert from 'utils/mixins/alert.mixin';
import { ParentApi } from '@/api/parent.api';
import CustomDatePicker from 'custom-date-picker';
import CustomInput from 'CustomInput';
import moment from 'moment';

extend('OnlyNumber', (value) => {
  let regex = /^([0-9]+)$/;
  if (value.search(regex) !== -1) return true;
  return 'campo solo acepta número (enteros y positivos).';
});

const parentApi = new ParentApi();

export default {
  name: 'StudentsInfo',
  mixins: [alert],
  components: {
    SectionTitle,
    StudentItem,
    DynamicFormList,
    DynamicFormListItem,
    ActionButton,
    CustomDatePicker,
    CustomInput,
  },
  data: () => ({
    model: {
      sie: null,
      ssn: null,
      birthdate: null,
    },
    studentinfo: {
      fullName: null,
      grade: null,
      age: null,
    },
    AddPanelshow: false,
    saveShow: false,
    resultPanelshow: false,
  }),
  props: {
    title: {
      type: String,
      default: 'Mis Estudiantes',
    },
    students: { type: Array, default: () => [] },
  },
  computed: {
    hasAnyItems() {
      return this.students.length > 0;
    },
  },
  methods: {
    async delete(item) {
      return await parentApi.deleteChild(item.studentSieId);
    },
    async remove(index) {
      let self = this;
      const item = self.students[index];
      const response = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea remover el estudiante ${item.name}?`,
        'Sí',
        'No'
      );

      if (response) {
        self
          .delete(item)
          .then(function(response) {
            const { status, message } = response;
            if (status === 'OK') {
              self.students.splice(index, 1);
              self.ShowToast(
                'Confirmación',
                message ||
                  'El estudiante ha sido eliminado de su cuenta de manera exitosa.',
                'success'
              );
            } else {
              self.ShowToast(
                'Alerta',
                message || 'Ocurrio un error, trate nuevamente.',
                'error'
              );
            }
          })
          .catch((err) => {
            if (err.response != null)
              this.ShowToast(
                'Alerta',
                err.response.data.message || 'error',
                'error',
                5000
              );
          });
      }
    },
    showHideAddPanel: function() {
      this.saveShow = false;
      this.AddPanelshow = !this.AddPanelshow;
      this.resultPanelshow = false;
      this.clearForm();
    },
    async saveHandler() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea agregar este estudiante?`,
        'Sí',
        'No'
      );
      if (!answer) return false;
      const post = await parentApi.linkStudentToParentAsync(this.model.sie);
      if (post == true) {
        this.clearForm();
        this.saveShow = false;
        this.resultPanelshow = false;
        this.AddPanelshow = !this.AddPanelshow;
        location.reload();
        this.ShowToast(
          'Confirmación',
          'El estudiante ha sido agregado de su cuenta de manera exitosa.',
          'success'
        );
      }
    },
    async studentAddInfo() {
      const valid = await this.$refs.StudentAdd.validate();
      if (!valid) {
        return;
      }
      let birthdate = moment(this.model.birthdate)
        .locale('es-PR')
        .format('YYYY-MM-DD')
        .replace(/ 0(?:0)?/, ' ');

      const info = await parentApi.getStudentinfo(
        this.model.sie,
        birthdate,
        this.model.ssn
      );
      if (info) {
        this.studentinfo = info;
        this.resultPanelshow = true;
        this.saveShow = true;
      }
      if (!info.isValid) {
        this.ShowToast(
          'Alerta',
          info.validationMessage || 'error',
          'error',
          5000
        );
      }
    },
    clearForm() {
      this.model.sie = null;
      this.model.ssn = null;
      this.model.birthdate = null;
    },
  },

  watch: {
    students: {
      handler() {
        const value = this.hasAnyItems;
        this.$emit('input', value);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
